const _temp0 = require("url:../pages/s2/home/bg.svg");

const _temp1 = require("url:../pages/s2/home/app/banner.svg");



const _temp2 = require("url:../pages/s2/assets/logo.svg");

const _temp3 = require("url:../pages/s2/assets/multiply.png");

const _temp4 = require("url:../pages/s2/assets/normal.png");

const _temp5 = require("url:../pages/s2/assets/preview.png");

const _temp6 = require("url:../pages/s2/assets/screen.png");



const _temp7 = require("url:../pages/react-aria/assets/datepicker-rtl.png");


const _temp8 = require("url:../pages/react-aria/examples/crud-dark.png");

const _temp9 = require("url:../pages/react-aria/examples/crud.png");

const _temp10 = require("url:../pages/react-aria/examples/emoji-picker-dark.png");

const _temp11 = require("url:../pages/react-aria/examples/emoji-picker.png");

const _temp12 = require("url:../pages/react-aria/examples/ios-list-dark.png");

const _temp13 = require("url:../pages/react-aria/examples/kanban-dark.png");

const _temp14 = require("url:../pages/react-aria/examples/kanban.png");

const _temp15 = require("url:../pages/react-aria/examples/photos-dark.png");

const _temp16 = require("url:../pages/react-aria/examples/photos.png");

const _temp17 = require("url:../pages/react-aria/examples/sheet-dark.png");

const _temp18 = require("url:../pages/react-aria/examples/sheet.png");

const _temp19 = require("url:../pages/react-aria/examples/swipeable-tabs-dark.png");

const _temp20 = require("url:../pages/react-aria/examples/swipeable-tabs.png");

const _temp21 = require("url:../pages/react-aria/examples/plants/plants/agapanthus.jpg");

const _temp22 = require("url:../pages/react-aria/examples/plants/plants/aloe.jpg");

const _temp23 = require("url:../pages/react-aria/examples/plants/plants/dracaena.jpg");

const _temp24 = require("url:../pages/react-aria/examples/plants/plants/fern.jpg");

const _temp25 = require("url:../pages/react-aria/examples/plants/plants/fig.jpg");

const _temp26 = require("url:../pages/react-aria/examples/plants/plants/gardenia.jpg");

const _temp27 = require("url:../pages/react-aria/examples/plants/plants/ivy.jpg");

const _temp28 = require("url:../pages/react-aria/examples/plants/plants/jacaranda.jpg");

const _temp29 = require("url:../pages/react-aria/examples/plants/plants/maidenhair.jpg");

const _temp30 = require("url:../pages/react-aria/examples/plants/plants/money.jpg");

const _temp31 = require("url:../pages/react-aria/examples/plants/plants/monstera.jpg");

const _temp32 = require("url:../pages/react-aria/examples/plants/plants/morning.jpg");

const _temp33 = require("url:../pages/react-aria/examples/plants/plants/nasturtium.jpg");

const _temp34 = require("url:../pages/react-aria/examples/plants/plants/oleander.jpg");

const _temp35 = require("url:../pages/react-aria/examples/plants/plants/poplar.jpg");

const _temp36 = require("url:../pages/react-aria/examples/plants/plants/spider.jpg");

const _temp37 = require("url:../pages/react-aria/examples/plants/plants/star.jpg");

const _temp38 = require("url:../pages/react-aria/examples/plants/plants/tree_fern.jpg");

const _temp39 = require("url:../pages/react-aria/examples/plants/plants/xmas.jpg");

const _temp40 = require("url:../pages/react-aria/examples/plants/plants/zz.jpg");





module.exports = {
  "s2":   {
    "home":     {
      "bg":       {
        "svg": _temp0
      },
      "app":       {
        "banner":         {
          "svg": _temp1
        }
      }
    },
    "assets":     {
      "logo":       {
        "svg": _temp2
      },
      "multiply":       {
        "png": _temp3
      },
      "normal":       {
        "png": _temp4
      },
      "preview":       {
        "png": _temp5
      },
      "screen":       {
        "png": _temp6
      }
    }
  },
  "react-aria":   {
    "assets":     {
      "datepicker-rtl":       {
        "png": _temp7
      }
    },
    "examples":     {
      "crud-dark":       {
        "png": _temp8
      },
      "crud":       {
        "png": _temp9
      },
      "emoji-picker-dark":       {
        "png": _temp10
      },
      "emoji-picker":       {
        "png": _temp11
      },
      "ios-list-dark":       {
        "png": _temp12
      },
      "kanban-dark":       {
        "png": _temp13
      },
      "kanban":       {
        "png": _temp14
      },
      "photos-dark":       {
        "png": _temp15
      },
      "photos":       {
        "png": _temp16
      },
      "sheet-dark":       {
        "png": _temp17
      },
      "sheet":       {
        "png": _temp18
      },
      "swipeable-tabs-dark":       {
        "png": _temp19
      },
      "swipeable-tabs":       {
        "png": _temp20
      },
      "plants":       {
        "plants":         {
          "agapanthus":           {
            "jpg": _temp21
          },
          "aloe":           {
            "jpg": _temp22
          },
          "dracaena":           {
            "jpg": _temp23
          },
          "fern":           {
            "jpg": _temp24
          },
          "fig":           {
            "jpg": _temp25
          },
          "gardenia":           {
            "jpg": _temp26
          },
          "ivy":           {
            "jpg": _temp27
          },
          "jacaranda":           {
            "jpg": _temp28
          },
          "maidenhair":           {
            "jpg": _temp29
          },
          "money":           {
            "jpg": _temp30
          },
          "monstera":           {
            "jpg": _temp31
          },
          "morning":           {
            "jpg": _temp32
          },
          "nasturtium":           {
            "jpg": _temp33
          },
          "oleander":           {
            "jpg": _temp34
          },
          "poplar":           {
            "jpg": _temp35
          },
          "spider":           {
            "jpg": _temp36
          },
          "star":           {
            "jpg": _temp37
          },
          "tree_fern":           {
            "jpg": _temp38
          },
          "xmas":           {
            "jpg": _temp39
          },
          "zz":           {
            "jpg": _temp40
          }
        }
      }
    }
  }
}